export default __webpack_public_path__ + "ebbaefddcb26555b79f6a04e6a320a20.png";